export default __webpack_public_path__ + "static/media/arrow-input-grey.52ea1fe1.svg";